const currency = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export function formatMoney(value) {
  if ((typeof value !== "number" && typeof value !== "string") || String(value).trim() === "") return "—";
  const number = Number(value);
  return Number.isFinite(number) ? currency.format(number) : "—";
}

export function formatDueDate(value) {
  if (typeof value !== "string") return "—";
  const parts = /^([1-9]\d{3})-(\d{2})-(\d{2})(?:$|[T ])/.exec(value);
  if (!parts) return "—";
  const [, year, month, day] = parts;
  const date = new Date(`${year}-${month}-${day}T12:00:00Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== `${year}-${month}-${day}`) return "—";
  return `${day}/${month}/${year}`;
}

export function paymentUrl(value) {
  if (typeof value !== "string" || Array.from(value).some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) return null;
  try {
    const url = new URL(value.trim());
    return ["https:", "http:"].includes(url.protocol) && !url.username && !url.password ? url.href : null;
  } catch (_) { return null; }
}

export function invoiceStatus(invoice) {
  const states = { paid: "Pago", open: "Em aberto", overdue: "Vencida" };
  const kind = Object.prototype.hasOwnProperty.call(states, invoice.displayStatus) ? invoice.displayStatus : "other";
  return { kind, label: states[kind] || String(invoice.status || "Não informada").trim() || "Não informada" };
}

export function quantityLabel(value, single, plural) {
  if (value === null || value === undefined || String(value).trim() === "" || !Number.isInteger(Number(value)) || Number(value) < 0) return `— ${plural}`;
  return `${Number(value)} ${Number(value) === 1 ? single : plural}`;
}